/**
 * Mirror decorative Tailwind classes (gradients, blobs, radial anchors) for RTL layouts.
 * Used on learner dashboard section shells so light falls from the mirrored corner in fa mode.
 */
export function mirrorRtlDecor(className: string, isRtl: boolean): string {
  if (!isRtl || !className) return className;

  let c = className;

  const gradientSwaps: [string, string][] = [
    ['bg-gradient-to-br', '__GRAD_BR__'],
    ['bg-gradient-to-bl', 'bg-gradient-to-br'],
    ['__GRAD_BR__', 'bg-gradient-to-bl'],
    ['bg-gradient-to-tr', '__GRAD_TR__'],
    ['bg-gradient-to-tl', 'bg-gradient-to-tr'],
    ['__GRAD_TR__', 'bg-gradient-to-tl'],
    ['bg-gradient-to-r', '__GRAD_R__'],
    ['bg-gradient-to-l', 'bg-gradient-to-r'],
    ['__GRAD_R__', 'bg-gradient-to-l'],
  ];
  for (const [from, to] of gradientSwaps) {
    c = c.split(from).join(to);
  }

  c = c.replace(/-left-/g, '-__POS_L__');
  c = c.replace(/-right-/g, '-left-');
  c = c.replace(/-__POS_L__/g, '-right-');

  c = c.replace(/at_100%_/g, 'at___X100___');
  c = c.replace(/at_0%_/g, 'at_100%_');
  c = c.replace(/at___X100___/g, 'at_0%_');

  return c;
}

/** Mirror inline linear-gradient angle for RTL (135° LTR → 225° RTL). */
export function mirrorLinearGradientAngle(angleDeg: number, isRtl: boolean): number {
  if (!isRtl) return angleDeg;
  return (360 - angleDeg) % 360;
}
